angular.module('nv.components.tooltip').component('nvTooltip', {
  template: require('./tooltip.html'),
  transclude: {
    externalBody: 'nvTooltipExternalBody',
    internalBody: 'nvTooltipInternalBody',
  },
  bindings: {
    title: '@',
  },
  controller: 'TooltipCtrl',
});
